import{__rest as r}from"../../../../../_virtual/_tslib.js";import{jsxs as e,jsx as t}from"react/jsx-runtime";import o from"styled-components";import{COLORS as d}from"../../../../../constants/Theme.js";import p from"../Property/PropertyNodes.js";const i=o.div`
	background: ${d.surface.subdued};
	border: 1px solid ${d.stroke.primary};
	border-radius: 4px;
	padding: 12px;
	width: 100%;
	display: flex;
	flex-direction: column;
`,n=o=>{var{children:d,node:n,addPropertyBtnText:s,deleteProperty:a,createProperty:c}=o,m=r(o,["children","node","addPropertyBtnText","deleteProperty","createProperty"]);return e(i,{children:[d,s&&t(p,Object.assign({node:n,addPropertyBtnText:s,deleteProperty:a,createProperty:c},m))]})};export{n as BaseQueryBuilderNode};
